const PREFIX = '@@HOT_SPOT';

export const UPDATE_HOT_SPOT = `${PREFIX}/UPDATE_HOT_SPOT`;
export const FETCHED_HOT_SPOT = `${PREFIX}/FETCHED_HOT_SPOT`;
export const DELETE_HOT_SPOT = `${PREFIX}/DELETE_HOT_SPOT`;
export const START_LOADING_HOT_SPOT = `${PREFIX}/START_LOADING_HOT_SPOT`;
export const END_LOADING_HOT_SPOT = `${PREFIX}/END_LOADING_HOT_SPOT`;
export const CREATE_HOT_SPOT = `${PREFIX}/CREATE_HOT_SPOT`;
